exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-body {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n}\n.insertion-iframe {\n    width: 100%;\n    height: 60vh;\n    border: none;\n}\n", ""]);

// exports
